<div class="card">
  <div class="card-header justify-content-between">
    <h3 class="card-title">Istorija aktivnosti</h3>
  </div>

  <table class="table table-hover table-outline table-vcenter card-table table-sticky">
    <thead>
    <tr>
      <th class="width-40">Aktivnost</th>
      <th class="width-20">Korisnik</th>
      <th class="width-20">Datum</th>
      <th class="width-10">Vreme</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let activity of activities; trackBy: trackByFn">
        <td style="white-space: pre-line;">{{activity.comment}}</td>
        <td>{{activity.userName}}</td>
        <td>{{activity.date | date:'dd/MM/yyyy'}}</td>
        <td>{{ customFunctions.getTime(activity.date) }}</td>
    </tr>
    </tbody>
  </table>

  <app-empty *ngIf="activities && activities.length < 1"></app-empty>
</div>